import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "course-menu bm-3 d-flex" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "px-4" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "col-lg-12 category-parent mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "p-3"
}
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "col-lg-12 category-parent mt-2" }

import { ref, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Course from '../../../api/v2/models/course'
import Tag from '../../../api/v2/models/course_tag'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'
import { getQueryString, getQueryNumber } from '../../../../helpers/route-helper'
import MenuTab from '../atoms_molecules/MenuTab.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseList',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const courses = ref<Course[]>([])
const tags = ref<Tag[]>([])
const mobile = ref(checkMobile())
const drawerRight = ref(!mobile.value)
const search = ref('')
const pageLoading = ref(false)

const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'コース一覧',
    disabled: false,
    exact: true,
    to: '/classroom/courses'
  }
]

// Type-safe computed properties for route query params
const currentTag = computed(() => getQueryString(route.query, 'tag'))
const currentTagNumber = computed(() => getQueryNumber(route.query, 'tag'))

const resetTag = () => {
  router.push({ query: {} })
}

const setTag = (id: number) => {
  router.push({ query: { tag: id } })
}

const loadCourses = async () => {
  const listId = currentTag.value
  courses.value = await api.course.index({ tagId: listId }).catch(() => [])
}

watch(search, async () => {
  const listId = currentTag.value
  courses.value = await api.course.index({ tagId: listId, search: search.value }).catch(() => [])
})

watch(() => route.query, async () => {
  await loadCourses()
}, { immediate: true })

onMounted(async () => {
  if (route.path.indexOf('/courses') !== -1) {
    headerState.setTitle('コース一覧')
  }
  const listId = currentTag.value
  courses.value = await api.course.index({ tagId: listId }).catch(() => [])
  tags.value = await api.courseTag.index()
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'コース一覧' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "8",
        cols: "12",
        class: "pt-0 bg-white"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_col, { lg: "10" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { to: "/classroom/my-courses" }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("マイコース", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_tab, { to: "/classroom/courses" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("コース一覧", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_col, { cols: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "search-form" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      search: search.value,
                      "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                      placeholder: "コース名を入力してください",
                      "prepend-icon": "mdi-database-search"
                    }, null, 8 /* PROPS */, ["search"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "me-2 mt-4 search-test",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (search.value = ''))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("クリア", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (course) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: course.id
            }, [
              _createVNode(_component_v_list_item, {
                to: `/classroom/courses/${course.id}`,
                cytag: "course-item"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    "min-height": "100",
                    "min-width": "100",
                    "max-height": "100",
                    "max-width": "100",
                    src: course.image.url
                  }, null, 8 /* PROPS */, ["src"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, {
                    textContent: _toDisplayString(course.name)
                  }, null, 8 /* PROPS */, ["textContent"]),
                  _createVNode(_component_v_list_item_subtitle, {
                    innerHTML: course.description
                  }, null, 8 /* PROPS */, ["innerHTML"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
              _createVNode(_component_v_divider)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }),
      (!mobile.value)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            lg: "3",
            cols: "12",
            class: "ms-3 bg-white"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "gray--text fs-4 fw-bold" }, "カテゴリー", -1 /* CACHED */)),
                _createElementVNode("a", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (resetTag())),
                      class: "mb-1 fw-bold"
                    }, "すべてのコース"),
                    _createVNode(_component_v_divider)
                  ])
                ]),
                _createVNode(_component_v_list, { color: "primary" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: tag.id,
                        onClick: ($event: any) => (setTag(tag.id)),
                        active: tag.id == currentTagNumber.value,
                        link: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name) + "(" + _toDisplayString(tag.courseCount) + ")", 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "active"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#header-right" }, [
      (mobile.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            icon: "",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (drawerRight.value = !drawerRight.value), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("menu", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#header-right-drawer" }, [
      (mobile.value)
        ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
            key: 0,
            modelValue: drawerRight.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((drawerRight).value = $event)),
            location: "right"
          }, {
            default: _withCtx(() => [
              (!pageLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createElementVNode("h2", null, "カテゴリー", -1 /* CACHED */)),
                    _createElementVNode("a", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (resetTag())),
                          class: "mb-1 fw-bold"
                        }, "すべてのコース"),
                        _createVNode(_component_v_divider)
                      ])
                    ]),
                    _createVNode(_component_v_list, { color: "primary" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: tag.id,
                            onClick: ($event: any) => (setTag(tag.id)),
                            active: tag.id == currentTagNumber.value,
                            link: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tag.name) + "(" + _toDisplayString(tag.courseCount) + ")", 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "active"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
    ]))
  ]))
}
}

})